import {SsrTypeBase} from "../ssr-type-base";

export abstract class OnlineCheckInBlockerSsr extends SsrTypeBase {
    get shouldBlockOnlineCheckIn(): boolean {
        return true;
    }
}
